import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, FormControlLabel, Radio, Switch, Button, TextField, RadioGroup, TableRow, TableBody, TableCell, Container, Typography, TableContainer } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import PagePicker from "src/components/page-picker/PagePicker";
import Uploader from "src/components/uploader/Uploader";
import CellImage from "src/components/common/CellImage";

const TABLE_HEAD = [
  { id: "image", label: "广告图", alignRight: false }, 
  { id: "url", label: "跳转地址", alignRight: false }, 
  { id: "order", label: "排序", alignRight: false }, 
  { id: "visible", label: "是否显示", alignRight: false }, 
  { id: "createdAt", label: "添加时间", alignRight: false }, 
  { id: "" }
];

const moreMenus = [
  { title: "编辑", icon: iconEdit2 },
  { title: "删除", icon: iconDelete },
];

export default function BannerList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [form, setForm] = useState({
    image: "",
    url: "",
    order: 0,
    isShow: 1,
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  function getItems() {
    axios
      .post("/diy/banner/all", filter)
      .then((res) => {
        const { code, msg, data, count } = res.data;
        if (code === 1) {
          setItems(data);
          setTotal(count);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTargetItem({ ...row });
      setAction("edit");
      setForm({
        image: row.image || "",
        url: row.url || "",
        isShow: Number(row.isShow),
        order: row.order,
      });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/diy/banner/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除轮播失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleAddItem() {
    setForm({
      image: "",
      url: "",
      order: 0,
      isShow: 1,
    });
    setAction("add");
  }

  function handleDialogConfirm() {
    if (!form.image) return alert("图片必须上传啊！！");

    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    axios
      .post(action === "add" ? "/diy/banner/add" : "/diy/banner/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
            setTotal(total + 1);
          } else if (action === "edit") {
            const banner = items.find((b) => b.id === targetItem.id);
            Object.assign(banner, form);
            items.sort((c1, c2) => c2.order - c1.order);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改轮播失败: ", err);
      });
  }

  function handleSelectLink() {
    PagePicker({
      onSelect(link) {
        // console.log(link);
        handleIptChange("url", link);
      },
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="轮播列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            轮播列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddItem}>
            添加轮播
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, image, isShow, createdAt, order, url } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">
                          <CellImage src={image} />
                        </TableCell>
                        <TableCell align="left">{url}</TableCell>
                        <TableCell align="left">{order}</TableCell>

                        <TableCell align="left">
                          <Switch checked={!!isShow} />
                        </TableCell>

                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加轮播" : "修改轮播"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="图片" required>
          <Stack direction="row" alignItems="flex-start">
            <Uploader images={form.image} onUploaded={(v) => handleIptChange("image", v)} />
          </Stack>
        </FormItem>

        <FormItem title="跳转地址">
          <TextField fullWidth placeholder="跳转地址" disabled autoComplete="off" id="url" value={form.url} size="small" onChange={(e) => handleIptChange("url", e.target.value)} />
          <Button style={{ whiteSpace: "nowrap" }} onClick={handleSelectLink}>
            选择地址
          </Button>
        </FormItem>

        <FormItem title="状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
            <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          </RadioGroup>
        </FormItem>

        <FormItem title="排序">
          <TextField fullWidth placeholder="排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
        </FormItem>
      </FormDialog>
    </Page>
  );
}
